import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilityService } from '../../core/services/utility.service';

@Injectable()
export class TestService {
  
  public acceptedFileTypes = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', '.exe', 'application/x-msdownload'];

  constructor(
    private http: HttpClient,
  ) { }

  //  We don't really have anything we need to clean or change in this test object, so we'll just validate
  public clean(obj: any) {}

  public onChange(obj: any) {
    
  }

  public getEditableFields(obj: any): Set<string> {
    // fields that are always editable
    obj.editableFields = new Set<string>(["allLabelCols", "allLabelColsSm", "allLabelColsMd", "allLabelColsLg",
      "allLabelColsXl", "allLabelColsXxl", "useOptionalSizes", "allIsEditable"]);

    // fields whose editability can be toggled
    if (obj.allIsEditable) {
        obj.editableFields = new Set<string>(["arrayBuilder", "arrayBuilder2", "booleanSlider", "date", "dateTime",
            "dropdown", "dropdownMulti", "monthYear", "richTextInput", "textInput", "textInputDollarsCents", "textInputDollarsOnly",
            "textInputCostCode", "textInputTypeahead", "textInputTypeahead2", "textInputTypeahead3", "textAreaInput",
            'fileUpload', "numberInput", "allLabelCols", "allLabelColsSm", "allLabelColsMd", "allLabelColsLg", "allLabelColsXl",
            "allLabelColsXxl", "useOptionalSizes", "allIsEditable", "radio", "time"]);
    }
    
    return obj.editableFields;
  }

  public validate(obj) {
    obj.errors = {};
    obj.warnings = {};   
    obj.isValid = true;

    const labelColsError = "Label width must be between 0-12";

    if (Number.isNaN(obj.allLabelCols) || obj.allLabelCols < 0 || obj.allLabelCols > 12)
      obj.errors['allLabelCols'] = labelColsError;

    const optionalCols = ['allLabelColsSm', 'allLabelColsMd', 'allLabelColsLg', 'allLabelColsXl', 'allLabelColsXxl'];

    for (let col of optionalCols) {
      if ((obj[col] != null) && (obj[col] < 0 || obj[col] > 12))
        obj.errors[col] = labelColsError;
    }
    var genericError = "Input set to default value";

    if (!obj.arrayBuilder?.length)
      obj.errors['arrayBuilder'] = genericError;

    if (!obj.arrayBuilder2?.length)
      obj.errors['arrayBuilder2'] = genericError;

    if (!obj.booleanSlider)
      obj.errors['booleanSlider'] = genericError;

    if ((obj.date == '') || (obj.date == UtilityService.nullDate) || (obj.date == UtilityService.nullDateString))
        obj.errors['date'] = genericError;

    if ((obj.dateTime == '') || (obj.dateTime == UtilityService.nullDate) || (obj.dateTime == UtilityService.nullDateString))
        obj.errors['dateTime'] = genericError;

    if (obj.time == '')
        obj.errors['time'] = genericError;

    if (obj.dropdown == '')
      obj.errors['dropdown'] = genericError;

    if (obj.dropdownMulti == '')
      obj.errors['dropdownMulti'] = genericError;

    if (!obj.fileUpload)
      obj.errors['fileUpload'] = genericError;

    if (!!obj.fileUpload) {
      //  We will normally use UtilityService.maxFileSize or a specific number if we're uploading somewhere with a more strict limit.
      if (obj.fileUpload.size > UtilityService.maxFileSize)
        obj.errors['fileUpload'] = `File is ${UtilityService.convertBytesToMegabytes(obj.fileUpload.size)}MB and the maximum upload size is 4MB.`;

      //  Example of how to restrict file types.  For the window to prompt with the correct file types you may need to do what we did for .exe files
      //  which is include the file extension and the official name of the file type (application/x-msdownload).
      if (!this.acceptedFileTypes.includes(obj.fileUpload.type))
        obj.errors['fileUpload'] = `Unaccepted file type.`;
    }

    if ((obj.monthYear == '') || (obj.monthYear == UtilityService.nullDateString) || (obj.monthYear == UtilityService.nullDateString))
      obj.errors['monthYear'] = genericError;

    if (obj.richTextInput == '')
        obj.errors['richTextInput'] = genericError;

    if ((obj.richTextInput != '') && obj.richTextInput?.length > 40)
        obj.errors['richTextInput'] = 'You have exceeded the max characters for the input.  The character count includes HTML characters.';

    if (obj.textInput == '')
      obj.errors['textInput'] = genericError;

    if (obj.textInputDollarsCents == '')
      obj.errors['textInputDollarsCents'] = genericError;
    if (obj.textInputDollarsOnly == '')
      obj.errors['textInputDollarsOnly'] = genericError;
    if (obj.textInputCostCode == '')
      obj.errors['textInputCostCode'] = genericError;

    if (obj.textInputTypeahead == '')
      obj.errors['textInputTypeahead'] = genericError;

    if (obj.numberInput == '')
      obj.errors['numberInput'] = genericError;
        
    if (obj.textAreaInput == '') {
      obj.errors['textAreaInput'] = 'Text area input is empty';
      // Test that warnings or errors appear when user is updating a different field
      obj.warnings['numberInput'] = 'Text area input is empty so show a warning';
    }

    if (obj.radio == '') {
      obj.errors['radio'] = 'Input is not selected';
    }

    if (obj.radio == 'chocolate') {
      obj.warnings['radio'] = 'Chocolate cake is selected';
    }

    if (Object.keys(obj.errors).length)
      obj.isValid = false;

    obj.syncAlerts?.();
    obj.editableFields$.next(this.getEditableFields(obj));
    
    return obj;
  }
}

